module.exports = __webpack_public_path__ + "static/media/move.497a40aa.svg";